<template>
  <div class="app-container">
    <div class="app-content">
      <el-card class="meter-list__card" shadow="never">
        <template slot="header">
          <el-form inline size="small">
            <el-form-item :label="$t('text.dbxlh')">
              <el-input
                v-model="tableQueryParams.sn"
                clearable
                :placeholder="$t('placeholder.srdb')"
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item :label="$t('text.cjqxlh')">
              <el-input
                v-model="tableQueryParams.gatewaysn"
                clearable
                :placeholder="$t('placeholder.srcjq')"
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item :label="$t('text.sbzt')">
              <el-select v-model="tableQueryParams.status" clearable @keyup.enter.native="handleQuery">
                <el-option :label="$t('text.zhenc')" value="0" />
                <el-option :label="$t('text.lx')" value="1" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-search"
                :loading="table.dataLoading"
                @click="handleQuery"
              >{{ $t('button.cx') }}</el-button>
              <el-button
                type="primary"
                icon="el-icon-plus"
                :loading="table.dataLoading"
                @click="addGateway.showDialog = true"
              >{{ $t('button.tianjia') }}</el-button>
            </el-form-item>
          </el-form>
        </template>
        <template slot="default">
          <div class="table-container">
            <el-table v-loading="table.dataLoading" height="100%" :data="table.dataList" element-loading-background="rgba(0, 0, 0, 0.7)">
              <el-table-column :label="$t('text.xh')" type="index" :index="indexCount" align="center" width="50" />
              <el-table-column :label="$t('text.bm')" prop="alias" />
              <el-table-column :label="$t('text.type')" prop="mtype" width="65" :formatter="MeterTypeFormat" />
              <el-table-column :label="$t('text.zt')" width="50">
                <template v-slot="scope">
                  <span v-if="scope.row.status === '0'" class="online">正常</span>
                  <span v-else class="offline">离线</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('text.tjfs')" prop="ts" width="80" :formatter="StatisticsTypeFormat" />
              <el-table-column :label="$t('text.meterMultiplier')" prop="mrate" width="100" :formatter="MeterMultiplierFormat" />
              <el-table-column :label="$t('text.cjqxlh')" prop="gatewaysn" />
              <el-table-column :label="$t('text.zyggl')" prop="pac" :formatter="numberParamFormat" />
              <el-table-column :label="$t('text.zxzdl')" prop="ftotal" :formatter="numberParamFormat" />
              <el-table-column :label="$t('text.fxzdl')" prop="rtotal" :formatter="numberParamFormat" />
              <el-table-column :label="$t('text.fspzmc')" :formatter="TimeShareNameFormat" />
              <el-table-column :label="$t('text.tysj')" prop="createtime" width="155" :formatter="TimeFormat" />
              <el-table-column :label="$t('text.gxsj')" prop="updatetime" width="155" :formatter="TimeFormat" />
              <el-table-column :label="$t('text.cz')" width="80">
                <template v-slot="scope">
                  <el-dropdown size="small" @command="handleRowCommand($event, scope.row)">
                    <el-button type="text" size="small" style="color: var(--primary-color)">
                      操作
                      <i class="el-icon-arrow-down el-icon--right" />
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="update" style="color: var(--primary-color)">设置电表信息</el-dropdown-item>
                      <el-dropdown-item command="setTimeShare" divided style="color: var(--warning-color)">设置统计方式</el-dropdown-item>
                      <el-dropdown-item command="delete" divided style="color: var(--danger-color)">删除电表设备</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagination">
            <el-pagination
              :current-page.sync="page.pageNum"
              :page-size="page.pageSize"
              :total="page.total"
              background
              layout="total, prev, pager, next"
              @current-change="queryTablePageData"
            />
          </div>
        </template>
      </el-card>

      <!-- 新增采集器弹窗 -->
      <el-dialog
        :title="$t('button.tianjia')"
        :visible.sync="addGateway.showDialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="600px"
        append-to-body
      >
        <el-form ref="addGatewayForm" :model="addGateway.formData" :rules="addGateway.formRules">
          <el-form-item :label="$t('text.cjqxlh')" prop="gatewaySn">
            <el-input v-model="addGateway.formData.gatewaySn" clearable />
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="addGateway.showDialog = false">{{ $t('button.qx') }}</el-button>
          <el-button type="primary" :loading="addGateway.submitLoading" @click="handleAddGatewaySubmit">{{ $t('button.qd') }}</el-button>
        </div>
      </el-dialog>

      <!-- 更新电表信息弹窗 -->
      <el-dialog
        :visible.sync="updateDevice.showDialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        title="设置电表信息"
        custom-class="meter-update__dialog"
        width="500px"
        append-to-body
      >
        <el-form ref="updateDeviceForm" :model="updateDevice.formData" :rules="updateDevice.formRules" size="small">
          <el-form-item :label="$t('text.dlbl')" prop="imrate">
            <el-input-number v-model="updateDevice.formData.imrate" :min="1" controls-position="right" />
          </el-form-item>
          <el-form-item :label="$t('text.dybl')" prop="umrate">
            <el-input-number v-model="updateDevice.formData.umrate" :min="1" controls-position="right" />
          </el-form-item>
          <el-form-item :label="$t('text.zbl')" prop="mrate">
            <el-input-number v-model="updateDevice.formData.mrate" :min="1" controls-position="right" />
          </el-form-item>
          <el-form-item :label="$t('text.bm')" prop="alias">
            <el-input v-model="updateDevice.formData.alias" clearable />
          </el-form-item>
          <el-form-item :label="$t('text.type')" prop="mtype">
            <el-select v-model="updateDevice.formData.mtype">
              <el-option label="光伏表" value="0" />
              <el-option label="市电表" value="1" />
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="updateDevice.showDialog = false">{{ $t('button.qx') }}</el-button>
          <el-button type="primary" :loading="updateDevice.submitLoading" @click="handleUpdateDeviceSubmit">{{ $t('button.qd') }}</el-button>
        </div>
      </el-dialog>

      <!-- 分时配置弹窗 -->
      <el-dialog
        :title="$t('text.fsyysz')"
        :visible.sync="setTimeShare.showDialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        custom-class="meter-rate__dialog"
        width="600px"
        append-to-body
      >
        <el-form ref="setTimeShareForm" :model="setTimeShare.formData" :rules="setTimeShare.formRules" size="small">
          <el-form-item :label="$t('text.cjqxlh')">
            <el-input v-model="setTimeShare.formData.gatewaySn" placeholder="" disabled />
          </el-form-item>
          <el-form-item :label="$t('text.tjfs')">
            <el-select v-model="setTimeShare.formData.statisticsType" placeholder="">
              <el-option label="系统统计" value="0" />
              <el-option label="电表统计" value="1" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('text.fspzmc')">
            <el-select v-model="setTimeShare.formData.timeShareId" placeholder="" filterable @change="handleTimeShareChange(setTimeShare.formData.timeShareId)">
              <el-option v-for="(item, index) in setTimeShare.timeShareList" :key="index" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('text.ratesdetail')">
            <el-descriptions title="" :column="1" class="rate-detail">
              <el-descriptions-item>
                <div slot="label">
                  &emsp;尖
                </div>
                {{ setTimeShare.timeShareView.sharp }}
              </el-descriptions-item>
              <el-descriptions-item>
                <div slot="label">
                  &emsp;峰
                </div>
                {{ setTimeShare.timeShareView.peak }}
              </el-descriptions-item>
              <el-descriptions-item>
                <div slot="label">
                  &emsp;平
                </div>
                {{ setTimeShare.timeShareView.flat }}
              </el-descriptions-item>
              <el-descriptions-item>
                <div slot="label">
                  &emsp;谷
                </div>
                {{ setTimeShare.timeShareView.valley }}
              </el-descriptions-item>
              <el-descriptions-item>
                <div slot="label">
                  深谷
                </div>
                {{ setTimeShare.timeShareView.dvalley }}
              </el-descriptions-item>
            </el-descriptions>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="setTimeShare.showDialog = false">{{ $t('button.qx') }}</el-button>
          <el-button type="primary" :loading="setTimeShare.submitLoading" @click="handleSetTimeShareSubmit">{{ $t('button.qd') }}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { QueryMeterReals, DeleteMeter, ApplyTimesShare, QueryTimesShareList } from '@/api/Meter'
import { BindGatewayToStation } from '@/api/Stations'
import { UpdateDevice } from '@/api/Device'
import dayjs from 'dayjs'

export default {
  name: 'MeterRealList',
  data () {
    return {

      /** 表格查询参数 */
      tableQueryParams: { stationid: this.$store.getters.station.id },

      /** 表格参数 */
      table: {
        dataLoading: false,
        dataList: []
      },

      /** 分页参数 */
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },

      /** 新增采集器弹窗参数 */
      addGateway: {
        /** 弹窗是否显示 */
        showDialog: false,

        /** 新增采集器表单数据 */
        formData: {
          /** 采集器编号 */
          gatewaySn: ''
        },

        /** 新增采集器表单验证规则 */
        formRules: {
          gatewaySn: [
            { required: true, message: '请输入采集器编号', trigger: 'blur' }
          ]
        },

        /** 提交加载状态 */
        submitLoading: false
      },

      /** 更新设备弹窗参数 */
      updateDevice: {
        /** 弹窗是否显示 */
        showDialog: false,

        /** 更新设备表单数据 */
        formData: {
          /** 设备ID */
          id: '',
          /** 设备别名 */
          alias: '',
          /** 电表倍率 */
          mrate: '',
          /** 电流倍率 */
          imrate: '',
          /** 电压倍率 */
          umrate: '',
          /** 电表类型 */
          mtype: '',
        },

        /** 更新设备表单验证规则 */
        formRules: {
        },

        /** 提交加载状态 */
        submitLoading: false
      },

      /** 设置分时配置弹窗参数 */
      setTimeShare: {
        /** 弹窗是否显示 */
        showDialog: false,
        /** 设置分时配置表单数据 */
        formData: {
          /** 采集器编号 */
          gatewaySn: '',
          /** 统计方式 */
          statisticsType: '',
          /** 分时配置ID */
          timeShareId: '',
        },
        /** 设置分时配置表单验证规则 */
        formRules: {
        },
        /** 分时配置列表 */
        timeShareList: [],
        /** 分时配置预览 */
        timeShareView: {
          sharp: '',
          peak: '',
          flat: '',
          valley: '',
          dvalley: ''
        },
        /** 提交加载状态 */
        submitLoading: false
      }
    }
  },
  computed: {

    /** 格式化电表类型显示 */
    MeterTypeFormat: function () {
      return (_row, _column, cellValue) => {
        if (cellValue === '0') {
          return '光伏表'
        } else if (cellValue === '1') {
          return '市电表'
        } else {
          return '--:--'
        }
      }
    },

    /** 格式化电表倍率显示 */
    MeterMultiplierFormat: function () {
      return (_row, _column, _cellValue) => {
        return _cellValue || '--'
      }
    },

    /** 格式化统计方式显示 */
    StatisticsTypeFormat: function () {
      return (_row, _column, cellValue) => {
        if (cellValue === '0') {
          return '系统统计'
        } else if (cellValue === '1' || !cellValue) {
          return '电表统计'
        }
      }
    },

    /** 格式化分时显示 */
    TimeShareNameFormat: function () {
      return (row, _column, _cellValue) => {
        const statisticalMethod = row.ts || '1'
        return statisticalMethod === '1' ? '电表统计' : row.timeshare
      }
    },

    /** 格式化时间显示 */
    TimeFormat: function () {
      return (_row, _column, cellValue) => {
        return cellValue ? dayjs(cellValue).format('YYYY-MM-DD HH:mm:ss') : '--:--'
      }
    },

    /** 格式化数字参数显示 */
    numberParamFormat: function () {
      return (row, _column, _cellValue) => {
        return _cellValue < 0 ? 'N/A' : _cellValue
      }
    },
  },
  mounted () {
    this.queryTimeShareList().then(() => {
      this.queryTablePageData()
    }).catch(() => {
      this.$message({
        type: 'error',
        message: '获取分时配置列表失败',
        duration: 1 * 1000
      })
    })
  },
  methods: {
    /** 分时配置改变 */
    handleTimeShareChange (id) {
      if (this.setTimeShare.timeShareList && this.setTimeShare.timeShareList.length > 0) {
        const rateInfo = this.setTimeShare.timeShareList.find(item => item.id === id)
        if (rateInfo) {
          const sharp = JSON.parse(rateInfo.sharp || '[]')
          const peak = JSON.parse(rateInfo.peak || '[]')
          const flat = JSON.parse(rateInfo.flat || '[]')
          const valley = JSON.parse(rateInfo.valley || '[]')
          const dvalley = JSON.parse(rateInfo.dvalley || '[]')
          this.setTimeShare.timeShareView.name = rateInfo.name || '--:--'
          this.setTimeShare.timeShareView.sharp = this.formatTimeShare(sharp)
          this.setTimeShare.timeShareView.peak = this.formatTimeShare(peak)
          this.setTimeShare.timeShareView.flat = this.formatTimeShare(flat)
          this.setTimeShare.timeShareView.valley = this.formatTimeShare(valley)
          this.setTimeShare.timeShareView.dvalley = this.formatTimeShare(dvalley)
        }
      }
    },
    /** 格式化分时配置 */
    formatTimeShare (timeShare) {
      return timeShare.map(({ s, e }) => {
        const start = `${s}`.padStart(2, '0')
        const end = `${e}`.padStart(2, '0')
        return `${start}:00-${end}:00`
      }).join('、') || '--:--'
    },
    /** 获取分时列表 */
    queryTimeShareList () {
      return new Promise((resolve, reject) => {
        QueryTimesShareList().then(res => {
          this.setTimeShare.timeShareList = res.data || []
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    /** 下拉菜单点击事件 */
    handleRowCommand (command, row) {
      if (command === 'update') {
        this.handleUpdate(row)
      } else if (command === 'setTimeShare') {
        this.handleSetTimeShare(row)
      } else if (command === 'delete') {
        this.handleDelete(row)
      }
    },
    /** 打开倍率修改界面 */
    handleUpdate (row) {
      if (!row.id) {
        this.$msgbox({
          title: '提示',
          type: 'error',
          message: '采集器还未上传电表数据,暂时无法更新电表信息',
        })
      } else {
        this.updateDevice.formData.id = row.id
        this.updateDevice.formData.alias = row.alias
        this.updateDevice.formData.mrate = row.mrate
        this.updateDevice.formData.imrate = row.imrate
        this.updateDevice.formData.umrate = row.umrate
        this.updateDevice.formData.mtype = row.mtype || '0'
        this.updateDevice.showDialog = true
      }
    },
    /** 根据ID删除设备 */
    handleDelete (row) {
      this.$confirm(this.$t('notice.scsb'), this.$t('notice.title'), {
        confirmButtonText: this.$t('button.qr'),
        cancelButtonText: this.$t('button.qx'),
        type: 'warning'
      })
        .then(() => {
          return DeleteMeter({ id: row.id })
        })
        .then(() => {
          this.$msgSuccess(this.$t('notice.sccg'))
          this.queryTablePageData()
        })
        .catch(() => { })
    },
    /** 打开分时弹窗 */
    handleSetTimeShare (row) {
      if (!row.timeshareid || row.timeshareid === '1') {
        this.setTimeShare.formData.timeShareId = row.timeshareid || '1'
        this.handleTimeShareChange(this.setTimeShare.formData.timeShareId)
      } else {
        this.setTimeShare.formData.timeShareId = row.timeshareid
        this.handleTimeShareChange(this.setTimeShare.formData.timeShareId)
      }
      this.setTimeShare.formData.gatewaySn = row.gatewaysn
      this.setTimeShare.formData.statisticsType = row.ts
      this.setTimeShare.showDialog = true
    },

    /** 获取表格数据 */
    queryTablePageData () {
      this.table.dataLoading = true
      QueryMeterReals({
        page: this.page.pageNum,
        perPage: this.page.pageSize,
        orderBy: 'alias',
        whereCondition: JSON.stringify(this.tableQueryParams)
      }).then(({ data }) => {
        this.table.dataList = data.queryResults || []
        this.page.total = data.totalCount || 0
      }).then(() => {
        this.table.dataLoading = false
      }).catch(() => {
        this.table.dataLoading = false
      })
    },
    /** 添加采集器提交表单 */
    handleAddGatewaySubmit () {
      this.$refs.addGatewayForm.validate(validateResult => {
        if (validateResult) {
          this.addGateway.submitLoading = true
          BindGatewayToStation({
            id: this.$store.getters.station.id,
            tag: this.addGateway.formData.gatewaySn
          }).then(() => {
            this.$msgSuccess(this.$t('notice.tjsbcg'))
            this.queryTablePageData()
            this.addGateway.submitLoading = false
            this.addGateway.showDialog = false
          }).catch(() => {
            this.addGateway.submitLoading = false
            this.addGateway.showDialog = false
          })
        }
      })
    },
    /** 更新设备提交表单 */
    handleUpdateDeviceSubmit () {
      this.$refs.updateDeviceForm.validate(validateResult => {
        if (validateResult) {
          this.updateDevice.submitLoading = true
          const postParam = {
            id: this.updateDevice.formData.id,
            alias: this.updateDevice.formData.alias,
            mrate: this.updateDevice.formData.mrate,
            irate: this.updateDevice.formData.imrate,
            urate: this.updateDevice.formData.umrate,
            mtype: this.updateDevice.formData.mtype,
          }
          UpdateDevice(postParam).then(() => {
            this.$message({
              message: this.$t('notice.xgcg'),
              type: 'success'
            }
            )
            this.updateDevice.submitLoading = false
            this.updateDevice.showDialog = false
            this.queryTablePageData()
          }).catch(() => {
            this.$message({
              message: this.$t('notice.sfjb'),
              type: 'error'
            })
            this.updateDevice.submitLoading = false
          })
        }
      })
    },
    /** 设置分时配置 */
    handleSetTimeShareSubmit () {
      this.$confirm('修改统计方式后会影响到尖峰平谷深谷电量的统计，请谨慎修改。', '提示!', {
        confirmButtonText: this.$t('button.qr'),
        cancelButtonText: this.$t('button.qx'),
        type: 'warning'
      }).then(() => {
        this.setTimeShare.submitLoading = true
        ApplyTimesShare({
          timeShareId: this.setTimeShare.formData.timeShareId,
          gatewaysn: this.setTimeShare.formData.gatewaySn,
          statisticsType: this.setTimeShare.formData.statisticsType
        }).then(() => {
          this.$message({
            type: 'success',
            message: '修改成功',
            duration: 1 * 1000
          })
          this.setTimeShare.submitLoading = false
          this.setTimeShare.showDialog = false
          this.queryTablePageData()
        }).catch(() => {
          this.setTimeShare.submitLoading = false
          this.setTimeShare.showDialog = false
        })
      })
    },

    /** 序号 */
    indexCount (index) {
      return (this.page.pageNum - 1) * this.page.pageSize + (index + 1)
    },
    /** 查询按钮 */
    handleQuery () {
      this.page.pageNum = 1
      this.queryTablePageData()
    },
  },
}
</script>

<style scoped>
.meter-list__card{
  width: 100%;
  height: 100%;
  padding: 0px;
  box-sizing: border-box;
  background-color: var(--card-bg-color);
  border-color: var(--card-bg-color);
}

.meter-list__card>>> .el-card__header {
  width: 100%;
  height: 50px;
  padding: 0 20px;
  box-sizing: border-box;
}
.meter-list__card>>> .el-card__header .el-form{
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.meter-list__card>>> .el-card__header .el-form .el-form-item{
  margin-bottom: 0;
}

.meter-list__card>>> .el-card__body {
  width: 100%;
  height: calc(100% - 50px);
  padding: 0 20px;
  box-sizing: border-box;
}

.meter-list__card>>> .el-card__body .table-container{
  width: 100%;
  height: calc(100% - 50px);
  padding: 0px;
  box-sizing: border-box;
}
.meter-list__card>>> .el-card__body .table-container .online{
  color: var(--online-color);
}
.meter-list__card>>> .el-card__body .table-container .offline{
  color: var(--alarm-color);
}

.meter-list__card>>> .el-card__body .pagination{
  width: 100%;
  height: 50px;
  padding: 0px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
<style>
.meter-update__dialog .el-dialog__body{
  padding: 20px;
  box-sizing: border-box;
}

.meter-rate__dialog .el-dialog__body{
  padding: 20px;
  box-sizing: border-box;
}
.meter-rate__dialog .el-descriptions__body{
  width: 100%;
  padding: 10px 10px;
  box-sizing: border-box;
  background-color: var(--card-bg-color);
  color: var(--primary-color);
  display: flex;
}
.meter-rate__dialog .el-descriptions__body .el-descriptions{
  width: 100%;
  display: flex;
}
.meter-rate__dialog .el-descriptions__body .el-descriptions__table{
  display: table-cell;
}

</style>
